module.exports = __webpack_public_path__ + "static/heroBG-a14ea2331374d1df90f3aff86493f0af.png";